export default function fixRichText(string: string, isHTML?: boolean) {
  const fixed = string
    .replace('&gt;', '>')
    .replace('&lt;', '<')
    .replace('&#39;', '\'')
    .replace('&quot;', '"');
  return isHTML ? decodeURI(fixed) : fixed;
}
